import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(theme => ({
  modalContainer: {
    margin: 0,
    padding: theme.spacing(1)
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.primary.main
  },

  dialogContentContainer: {
    padding: 0,
    height: 364
  },
  contentInfo: {
    textAlign: "center",
    fontSize: "20px"
  },
  titleModal: {
    fontWeight: "bold",
    fontSize: 18,
    color: theme.palette.primary.main
  },
  reactPlayerStyle: {
    [theme.breakpoints.down("xs")]: {
      width: "100% !important"
    }
  }
}));

export default styles;
